import React, { FC, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import { getOrdersAction, updateAllOrderStatusActions, updateOrderStatusActions } from '../../orders/actions';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
} from '../../deliveryOrders/selectors';

import theme from '../../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Box,
  Slide,
} from '@material-ui/core';

import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiPlusBoxMultipleOutline,
  mdiClose,
  mdiTruckDeliveryOutline,
  mdiAccountOutline, mdiPackageVariant
} from '@mdi/js';

import Client from 'client-sdk/src/client';

import Orderedlist from '../../createBundle/orderedlist';

import { SelectorProps, Payload, Props } from '../edit/interfaces';
import { Order } from '../../orders/interfaces';
import {
  GetAllOrdersRequestBuilder,
  UpdateBundleOrdersRuequestBuilder,
} from 'client-sdk/src/orders/orders';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../../utils/handleError';
import List from './list';
import handleNotfication from '../../../utils/handleNotfication';
import { removeEmptyValueObject, flattenObject } from '../../../utils/helpers';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    inputHolder: {
      flex: 1,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
  })
);

type Inputs = {
  'customerNationalCode.contains': string;
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditBundle: FC<Props> = ({
  ordersList,
  orderDispatch,
  updateOrdersStatusDispatch,
  updateOrderStatusDispatch,
  match,
  loading,
  history,
}: Props): React.ReactElement => {
  const classes = useStyles();
  const token = localStorage.getItem('token') || '';
  const [bundleId] = useState<number>(match?.params?.id);
  const [addModal, setAddModal] = useState(false as boolean);
  const [allOrdersLoading, setAllOrdersLoading] = useState(false as boolean);
  const [allOrders, setAllOrders] = useState<Order[]>([]);
  const [orders, setOrders] = useState<Order[]>([]);
  const [updateOrdersDialog, setUpdateOrderDialog] = useState(false as boolean);
  const [updatedData, setUpdatedData] = useState<Order[]>([]);
  const [filtersValues, setFiltersValues] = useState({
    'deliveryType.notEquals': 'POST',
    size: 500,
    sort: 'id,desc',
  });
  const [filters, setFilters] = useState([]);
  const [numSelected, setNumSelected] = useState(0);
  const [selectedList, setSelectedList] = useState([] as Order[]);
  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام مشتری',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
    ]);
  };
  // useEffect(() => {
  //   if (ordersList?.length) {
  //     setOrders(ordersList);
  //   }
  // }, [ordersList]);

  useEffect(() => {
    if (bundleId) {
      orderDispatch({
        bundleId: { equals: bundleId },
        deliveryType: { notEquals: 'POST' },
        size: 500,
      });
    }
  }, []);
  useEffect(() => {
    if (bundleId) {
      orderDispatchHandler({
        bundleId: { equals: bundleId },
        deliveryType: { notEquals: 'POST' },
        size: 500,
      });
    }
  }, [bundleId]);
  const orderDispatchHandler = async (actions: any) => {
    const payload = { ...actions }
    try {
      const { response, count } = await ordersRepository.getOrders({ payload });
      setOrders(response.data);
    } catch (err) {
      handleError(err.response);
    }
  }
  useEffect(() => {
    if (addModal) {
      setupFilters();
      fetchAllOrders();
    }
    const storedId = JSON.parse(localStorage.getItem('bundleId'));
    setSelectedList(storedId);
  }, [addModal, filtersValues]);
  useEffect(() => {
    const storedId = JSON.parse(localStorage.getItem('bundleId'));
    if (storedId) {
      localStorage.removeItem('bundleId');
    }
    localStorage.setItem('bundleId', JSON.stringify(selectedList));
  }, [selectedList]);
  const fetchAllOrders = async () => {
    try {
      setAllOrdersLoading(true);
      const makeOrdersRequest = new GetAllOrdersRequestBuilder()
        .params(flattenObject({
          ...filtersValues,
        }))
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeOrdersRequest);
      setAllOrders(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setAllOrdersLoading(false);
    }
  };
  const handleSelectItem = (selected: Order[], num: any) => {
    setSelectedList(selected);
    setNumSelected(num);
  };
  const updateBundleOrders = async () => {
    try {
      setAllOrdersLoading(true);
      const makeUpdateRequest = new UpdateBundleOrdersRuequestBuilder()
        .id(bundleId)
        .data({ orders: updatedData.map(el => el.id) })
        .build();
      const client = new Client(token);
      await client.execute(makeUpdateRequest);
      handleNotfication('مرسوله مورد نظر با موفقیت ویرایش شد', 'success');
      history.push('/bundles');
    } catch (err) {
      handleError(err.response);
    } finally {
      setAllOrdersLoading(false);
    }
  };

  const handleEditOrders = (values: Order[]) => {
    setUpdatedData(values);
    setUpdateOrderDialog(true);
  };

  const handleOpenAddModal = () => {
    setAddModal(true);
  };

  const handleCloseAddModal = () => {
    setAddModal(false);
  };

  const handleAddNewOrders = (values: Order[]) => {
    const ids = values.map(value => value.id);
    changeOrdersStatusHandler(ids, '', 'BUNDLED')
    setOrders(prevState => [...prevState, ...values]);
    setAddModal(false);
  };
  const changeOrdersStatusHandler = (id: any, descrip: string, stat: string) => {
    updateOrdersStatusDispatch({
      ids: id,
      descrption: `${descrip}`,
      status: stat
    })
  }
  const changeStatusHandler = (id: any, values: any) => {
    updateOrderStatusDispatch({
      id,
      body: { description: null, status: 'PACKAGED' },
    });
    setOrders(prevState => [...values]);
  }
  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography
            variant="h4"
            component="div"
            style={{ marginLeft: '20px', fontSize: '18px' }}
          >
            {`ویرایش مرسوله ${match?.params?.id}`}
          </Typography>
        </Grid>
        <Grid container item xs={12} alignItems="center">
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>
        <Grid container spacing={3}>
          <Grid container item xs={12} direction="row-reverse">
            <Button
              variant="contained"
              color="secondary"
              aria-label="assignment"
              size="large"
              onClick={handleOpenAddModal}
            >
              <Icon
                path={mdiPlusBoxMultipleOutline}
                size={1}
                className={classes.icon}
              />
              {'اضافه کردن سفارش'}
            </Button>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <Orderedlist
                data={orders}
                loading={loading}
                editMode={true}
                handleOpenSelectDriver={handleEditOrders}
                changeStatus={changeStatusHandler}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={addModal}
        fullScreen
        TransitionComponent={Transition}
        onClose={handleCloseAddModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              top: '5px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseAddModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <Box mb={5} />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {allOrdersLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <>
                  <List
                    sourceName={
                      ordersList?.[0]?.sourceName
                        ? ordersList?.[0]?.sourceName
                        : ordersList?.[0]?.fulfillmentWarehouseName
                    }
                    handleSelectedList={handleAddNewOrders}
                    handleSelectedItem={handleSelectItem}
                    loading={allOrdersLoading}
                    data={allOrders}
                    filters={filters}
                    onFilter={(filtervalues: any) => {
                      setFiltersValues({
                        ...removeEmptyValueObject(filtervalues),
                        page: 0,
                        size: 100,
                      });
                    }}
                    filtersValue={filtersValues}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={updateOrdersDialog}
        fullWidth
        TransitionComponent={Transition}
        onClose={() => setUpdateOrderDialog(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => setUpdateOrderDialog(false)}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div>آیا از ویرایش مرسوله {bundleId} مطمئن هستید؟</div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setUpdateOrderDialog(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                disabled={allOrdersLoading}
                onClick={updateBundleOrders}
                variant="contained"
                size="large"
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  loading: makeSelectLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    orderDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    updateOrdersStatusDispatch: (payload: Payload) => dispatch(updateAllOrderStatusActions(payload)),
    updateOrderStatusDispatch: (payload: Payload) => dispatch(updateOrderStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(EditBundle);
